export default "__VITE_ASSET__CaEti64y__"